<template>
  <div class="divContainer">
    <div v-if="loading" v-loading="loading" class="fullContainer"></div>
    <div v-else class="container">
      <div class="main">
        <el-descriptions title="" direction="vertical" :column="1" border>
          <el-descriptions-item label="配置名称">{{
            info.title
          }}</el-descriptions-item>
          <el-descriptions-item label="更新时间">{{
            info.updateTime
          }}</el-descriptions-item>
          <el-descriptions-item label="设备型号">
            <el-tag size="small" class="mr-10">{{ info.device }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="语言">
            <el-tag size="small" class="mr-10">{{ info.language }}</el-tag>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <footer class="bottomContainer">
        <div>
          <el-button size="small" type="info" @click="deleteData"
          v-check-role
            >删除</el-button
          >

          <el-button type="warning" size="small" @click="download"
            >下载</el-button
          >
        </div>
        <div>
          <el-button size="small" style="margin-right: 10px" @click="goBack"
            >取消</el-button
          >
          <router-link
            :to="{
              path: '/config/autoLayout/edit/' + this.$route.params.id
            }"
          >
            <el-button type="primary" size="small" v-check-role>编辑</el-button>
          </router-link>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import { getConfigById, deleteConfig } from '../../../api/autoLayoutManage'
export default {
  name: 'info',
  data() {
    return {
      info: {},
      loading: false
    }
  },
  created() {
    this.loading = true
    getConfigById(this.$route.params.id)
      .then((res) => {
        if (res.success) {
          this.info = res.data
        }
      })
      .catch((err) => {
        this.$message.error(err)
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    download() {
      const a = document.createElement('a')
      a.href = this.info.configUrl
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    deleteData() {
      this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteConfig(this.$route.params.id).then((res) => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
              this.$router.push('/config/autoLayout/list')
            }
          })
        })
        .catch((err) => {
          this.$message({
            type: 'info',
            message: '取消删除'
          })
        })
    },
    goBack() {
      this.$router.back(-1)
    }
  }
}
</script>
<style scoped>
.divContainer {
  height: 100%;
}
.mr-10 {
  margin-right: 10px;
}
.bottomContainer {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  box-shadow: 0px 2px 5px #888;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}
.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: calc(100vh - 60px);
}
.fullContainer {
  width: 100%;
  height: 100%;
}
.main {
  padding: 20px;
}
</style>
